import { IItem } from '../models/IItem'

export enum FeasibilityCheckSupplierMode {
  AllSuppliers = 1,
  InternalOnly = 2,
  InternalFirst = 3,
}

export const FeasibilityCheckSupplierModeList = [
  { name: null, label: null, id:null },//fake element here to make the index match the enum, so we can look up by id to get the name
  { name: "AllSuppliers", label: "Check all suppliers", id: FeasibilityCheckSupplierMode.AllSuppliers},
  { name: "InternalOnly", label: "Check only internal suppliers", id: FeasibilityCheckSupplierMode.InternalOnly},
  { name: "InternalFirst", label: "Check internal suppliers first and external for remaining", id: FeasibilityCheckSupplierMode.InternalFirst},
];

export function FeasibilityCheckSupplierModeById(mode: FeasibilityCheckSupplierMode): IItem {
  for (var f of FeasibilityCheckSupplierModeList) {
    if (f.id == mode)
      return f;
  }
  return FeasibilityCheckSupplierModeList[1];
}

export function FeasibilityCheckSupplierModeByName(name: string): IItem {
  for (var f of FeasibilityCheckSupplierModeList) {
    if (f.name == name)
      return f;
  }
  return FeasibilityCheckSupplierModeList[1];
}



// WEBPACK FOOTER //
// ./src/app/enums/feasibility-check-supplier-mode.enum.ts